'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Avatar = require('../../01.atoms/Avatar/Avatar.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-quote',
    cnImage = "".concat(CLASSNAME, "__image"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnContentLarge = "".concat(cnContent, "--large"),
    cnAuthor = "".concat(CLASSNAME, "__author"),
    cnTick = "".concat(CLASSNAME, "__tick");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Quote(_ref) {
  var author = _ref.author,
      authorInfo = _ref.authorInfo,
      image = _ref.image,
      quote = _ref.quote,
      style = _ref.style;
  return /*#__PURE__*/React__default.createElement("figure", {
    className: classNames(CLASSNAME, _rollupPluginBabelHelpers.defineProperty({}, "".concat(CLASSNAME, "--").concat(style), style))
  }, /*#__PURE__*/React__default.createElement("blockquote", {
    className: classNames(cnContent, _rollupPluginBabelHelpers.defineProperty({}, cnContentLarge, (quote === null || quote === void 0 ? void 0 : quote.length) < 51))
  }, "\u201C", quote, "\u201D", /*#__PURE__*/React__default.createElement("div", {
    className: cnTick
  })), /*#__PURE__*/React__default.createElement("figcaption", {
    className: cnAuthor
  }, image && /*#__PURE__*/React__default.createElement(Avatar, {
    className: cnImage,
    image: image,
    size: "sm"
  }), author, authorInfo ? " \u2013 ".concat(authorInfo) : ''));
}
Quote.propTypes = {
  /** Name of author */
  author: PropTypes.string.isRequired,

  /** Additional author info */
  authorInfo: PropTypes.string,

  /** Optional author avatar image */
  image: PropTypes.string,

  /** Actual quote */
  quote: PropTypes.string.isRequired,

  /** Choose between styles */
  style: PropTypes.oneOf(['dark', 'light'])
};

module.exports = Quote;
